import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Film, Tags, Users, UploadCloud, ArrowLeft, Loader2, UserCog, MessageSquare, Mail } from "lucide-react";

export default function AdminLayout() {
  const { t } = useTranslation();
  const { isStaff, ready, user } = useAuth();

  if (!ready) return <div className="flex h-screen items-center justify-center bg-background"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  if (!isStaff) return <Navigate to="/login" replace />;

  const items = [
    { to: "/admin", end: true, icon: LayoutDashboard, label: t("admin.dashboard") },
    { to: "/admin/videos", icon: Film, label: t("admin.videos") },
    { to: "/admin/categories", icon: Tags, label: t("admin.categories") },
    { to: "/admin/creators", icon: Users, label: t("admin.creators") },
    { to: "/admin/users", icon: UserCog, label: "Utilisateurs" },
    { to: "/admin/email", icon: Mail, label: "E-mails" },
    { to: "/admin/ask-vytali", icon: MessageSquare, label: "Ask Vytali" },
    { to: "/admin/pipeline", icon: UploadCloud, label: t("admin.uploadTest") },
  ];

  return (
    <div className="flex min-h-screen bg-background">
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-60 flex-col border-r border-white/5 bg-[hsl(var(--surface))] p-4 md:flex">
        <Link to="/" className="mb-8 flex items-center gap-2 px-2 font-heading text-xl font-black tracking-tight">
          Vytali<span className="text-primary">Flix</span>
        </Link>
        <nav className="flex flex-1 flex-col gap-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`admin-nav-${it.label}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${
                  isActive ? "bg-primary/15 text-primary" : "text-muted-foreground hover:bg-white/5 hover:text-foreground"
                }`
              }
            >
              <it.icon className="h-4 w-4" /> {it.label}
            </NavLink>
          ))}
        </nav>
        <Link to="/" className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-muted-foreground transition-colors hover:text-foreground">
          <ArrowLeft className="h-4 w-4" /> {t("common.backHome")}
        </Link>
        <div className="mt-2 rounded-lg bg-white/5 px-3 py-2 text-xs text-muted-foreground">
          {user?.name} · {user?.role}
        </div>
      </aside>

      <div className="flex-1 md:ml-60">
        {/* mobile top bar */}
        <div className="flex items-center gap-2 overflow-x-auto border-b border-white/5 bg-[hsl(var(--surface))] px-4 py-3 md:hidden">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end}
              className={({ isActive }) => `whitespace-nowrap rounded-full px-3 py-1.5 text-xs ${isActive ? "bg-primary text-primary-foreground" : "bg-white/5 text-muted-foreground"}`}>
              {it.label}
            </NavLink>
          ))}
        </div>
        <div className="p-5 md:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
